export default () => ({
  list: [],
  metaList: []
})
